<template>
  <!-- modal -->
  <div class="dimed wrap">
    <div class="layer no-line-height">
      <div class="layer__header">
        <div class="lyr-title">{{ $t('Modal.Sign.msg1') }}</div>
        <div class="ft-point">{{ $t('Modal.Sign.msg2') }}</div>
        <div class="lyr-txt">{{ $t('Modal.Sign.msg3') }}</div>
      </div>
      <div class="layer__body">
        <div class="sign-box">
          <div class="lyr-txt" style="padding-top: var(--txt-pd10)">{{ $t('Modal.Sign.msg4') }}</div>
          <div style="position: absolute; top: 7vw; width: 58.5vw; height: 15.8vh">
            <canvas
              class="sign-area"
              @touchstart="touchdraw($event)"
              @mousedown="draw($event)"
              @mouseout="draw($event)"
              @touchend="touchdraw($event)"
              @mouseup="draw($event)"
              @mousemove="draw($event)"
              @touchmove="touchdraw($event)"
              @touchcancel="touchdraw($event)"
            ></canvas>
          </div>
        </div>
        <div class="sign-tot-amount">
          <span class="lyr-txt no-margin">{{ $t('Modal.Sign.msg5') }}</span>
          <span class="ft-point">{{ $displayUprc(tran.HEADER.TOT_SALES_AMT) }}</span>
        </div>
      </div>
      <div class="layer__button">
        <button class="btn btn--cancel btn-anim" @mouseup="$emit('closeSign')">{{ $t('Modal.Sign.msg6') }}</button>
        <button class="btn btn--submit btn-anim" :class="{disabled: !downloadYn}" :disabled="!downloadYn" @mouseup="paymentEnd()">
          {{ $t('Modal.Sign.msg7') }}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'sign',
  data() {
    return {
      darkModeYn: this.$store.getters.getDarkModeYn,
      dragStartYn: false,
      positionX: 0,
      positionY: 0,
      canvas: null,
      ctx: null,
      downloadYn: false,
      currUnitText: this.$store.getters.getCurrUnitText,
      ongoingTouches: [],
      drawble: false,
      oneCallYn: false,
      posTransactionYn: false,
      tranUrl: '',
      text: '',
    };
  },
  mounted() {
    this.drawReady();
    this.canvasResize();
  },
  props: {
    tran: Object,
    instalmentNum: String,
    totalUprc: Number,
  },
  methods: {
    drawReady() {
      this.canvas = document.querySelector('canvas');
      this.ctx = this.canvas.getContext('2d');
      this.ctx.lineWidth = 4;
      this.drawble = false;
    },
    canvasResize() {
      this.canvas.height = this.canvas.offsetParent.clientHeight;
      this.canvas.width = this.canvas.offsetParent.clientWidth;
    },
    draw(e) {
      let getPosition = {
        x: e.offsetX,
        y: e.offsetY,
      };

      switch (e.type) {
        case 'mousedown':
          {
            this.drawble = true;
            this.ctx.beginPath();
            this.ctx.moveTo(getPosition.x, getPosition.y);
          }
          break;
        case 'mousemove':
          {
            if (this.drawble) {
              this.downloadYn = this.ctx.getImageData(0, 0, this.canvas.width, this.canvas.height).data.some((channel) => channel !== 0);
              this.ctx.lineTo(getPosition.x, getPosition.y);
              this.ctx.stroke();
            }
          }
          break;
        case 'mouseup':
        case 'mouseout':
          {
            this.drawble = false;
            if (this.ctx != null) this.ctx.closePath();
          }
          break;
      }
    },
    paymentEnd() {
      let tranObj = {
        tranNo: this.tran.tranNo,
        orderNo: this.tran.orderNo,
        payType: 'CARD',
        totalUprc: this.totalUprc,
      };
      this.$emit('setPayComplete', tranObj);
    },
  },
  computed: {
    darkMode: function () {
      return this.$store.getters.getDarkModeYn;
    },
  },
  watch: {
    darkMode() {
      this.darkModeYn = this.darkModeYn ? false : true;

      this.$changeDarkMode(this.darkModeYn);
    },
  },
  components: {},
};
</script>

<style src="@/assets/css/user/common.css" scoped></style>
<style src="@/assets/css/user/dark/common-dark.css" scoped></style>
<style scoped>
.no-line-height {
  line-height: 0.3em;
}

.lyr-txt {
  line-height: 1.6em;
  margin-top: 0px;
}

.sign-box {
  width: 62.2vw;
  height: 20.8vh;
  border-radius: 20px;
  background-color: #f2f2f2;
  border: 2px solid #f2f2f2;
  padding: 0px 20px;
  position: relative;
  margin-bottom: var(--txt-pd20);
}

.sign-area {
  width: 100%;
  height: 100%;
  border-radius: 20px;
  background-color: #ffffff;
}

.sign-tot-amount .ft-point {
  font-size: 2em;
  margin-left: 30px;
  vertical-align: middle;
}

.sign-tot-amount .lyr-txt {
  font-size: 1.4em;
  vertical-align: middle;
}

.dark .sign-box {
  background: var(--bg-color-dark);
  border: 2px solid var(--border-color-dark);
}
</style>
